import axios from '@/plugins/axios'

const getBook = async slug => {
  try {
    const response = await axios.get(`books/${slug}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getBooks = async function ({
  userId = null,
  categoryId = null,
  genreId = null,
  visibility = null,
  license = null,
  search = null,
  isPublicDomain = null,
  isPaid = null,
  isScrivPro = null,
  tagId = null,
  page = 1,
  sort = null,
  orderBy = null,
  all = null
}) {
  try {
    const params = {}
    if (userId) params.user_id = userId
    if (tagId) params.tag_id = tagId
    if (categoryId) params.category_id = categoryId
    if (genreId) params.genre_id = genreId
    if (visibility) params.visibility = visibility
    if (license) params.license = license
    if (search) params.search = search
    if (isPublicDomain !== null) params.is_public_domain = isPublicDomain ? 1 : 0
    if (isPaid !== null) params.is_paid = isPaid ? 1 : 0
    if (isScrivPro !== null) params.is_scriv_pro = isScrivPro ? 1 : 0
    if (all !== null) params.all = all ? 1 : 0
    if (sort) params.sort = sort
    if (orderBy) params.order_by = orderBy
    params.page = page

    const response = await axios.get('books', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

// eslint-disable-next-line camelcase
const post = async (id = null, { title = '', slug = '', description = '', category_id = '', visibility = 'public', license = 'cc0', content = '', amount = '', is_comments_enabled = true, cover = null, tags = [], genres = [], number_of_pages = null }) => {
  try {
    const form = new FormData()
    form.append('title', title || '')
    form.append('visibility', visibility)
    form.append('license', license)
    form.append('category_id', category_id)
    // eslint-disable-next-line camelcase
    form.append('status', 'published')
    // eslint-disable-next-line camelcase
    form.append('is_comments_enabled', is_comments_enabled ? 1 : 0)
    if (slug) form.append('slug', slug || '')
    if (description) form.append('description', description || '')
    if (cover) form.append('cover', cover)
    if (id) form.append('_method', 'PUT')
    if (tags) form.append('tags', tags)
    if (genres) form.append('genres', genres)
    if (amount) form.append('amount', parseInt(amount * 100))
    // eslint-disable-next-line camelcase
    if (number_of_pages) form.append('number_of_pages', number_of_pages)
    const url = id ? `books/${id}` : 'books'
    // console.log(url, name, slug, description, visibility, cover)
    const response = await axios.post(url, form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const destroyBook = async id => {
  try {
    const response = await axios.post(`books/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const toggleChaptersVisibility = async (id, visibility) => {
  try {
    const response = await axios.post(`books/${id}/toggle-chapters-visibility`, {
      visibility: visibility,
      _method: 'PUT'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Make request to send epub to kindle
 * @returns
 */
const sendBookToKindle = async ({
  id,
  email
}) => {
  try {
    const response = await axios.post(`books/${id}/send-to-kindle`, {
      email: email,
      _method: 'PUT'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Upload file
 */
const uploadFile = async (id, { type, file }) => {
  try {
    const form = new FormData()
    form.append('type', type)
    form.append('file', file)
    // console.log(url, name, slug, description, visibility, cover)
    const response = await axios.post(`books/${id}/files`, form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const destroyBookFile = async (bookId, fileId) => {
  try {
    const response = await axios.post(`books/${bookId}/files/${fileId}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const downloadBookFile = async (bookId, fileId) => {
  try {
    const response = await axios.get(`books/${bookId}/files/${fileId}`, {
      responseType: 'arraybuffer'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Purchase book using scriv pro
 *
 * @param {*} id
 */
const purchaseBookWithScrivPro = async id => {
  try {
    const response = await axios.post(`books/${id}/scriv-pro`, {
      _method: 'PUT'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  destroyBook,
  destroyBookFile,
  downloadBookFile,
  getBook,
  getBooks,
  post,
  purchaseBookWithScrivPro,
  toggleChaptersVisibility,
  sendBookToKindle,
  uploadFile
}
